import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: null,
    token: localStorage.getItem('token') || ''
  },
  reducers: {
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
    logout(state) {
      state.userInfo = null;
      state.token = '';
      localStorage.removeItem('token');
    }
  }
});

export const { setUserInfo, setToken, logout } = userSlice.actions;
export default userSlice.reducer;
